import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "migrate-message-queue-configuration"
    }}>{`Migrate message queue configuration`}</h1>
    <h2 {...{
      "id": "migrate-from-21-to-22"
    }}>{`Migrate from 2.1 to 2.2`}</h2>
    <p>{`To upgrade the message queues for Adobe Commerce or Magento Open Source 2.1, you must create the following files in the `}<inlineCode parentName="p">{`<module>/etc`}</inlineCode>{` directory for each module that will use the message queue framework.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`queue_consumer.xml`}</inlineCode>{` - Defines the relationship between an existing queue and its consumer.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_topology.xml`}</inlineCode>{`- Defines the message routing rules and declares queues and exchanges.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_publisher.xml`}</inlineCode>{` -   Defines the exchange where a topic is published.`}</li>
    </ul>
    <p>{`The existing `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file is deprecated.`}</p>
    <p>{`For complete details about these files, see `}<a parentName="p" {...{
        "href": "configuration.md"
      }}>{`Configure message queues`}</a></p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`The Adobe Commerce and Magento Open Source 2.1 `}<inlineCode parentName="p">{`communication.xml`}</inlineCode>{` file has not changed for Adobe Commerce and Magento Open Source 2.2.`}</p>
    <h3 {...{
      "id": "create-the-queue_consumerxml-file"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_consumer.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_consumer.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.1 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.1 queue.xml source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/consumer`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/queue`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/name`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/handler`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/handler`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/consumerInstance`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/consumerInstance`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/connection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/type`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/maxMessages`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/maxMessages`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "create-the-queue_topologyxml-file"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_topology.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_topology.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.1 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.1 queue.xml source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/exchange`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Set this value to `}<inlineCode parentName="td">{`topic`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/connection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/type`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/durable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/autoDelete`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/internal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. It is recommended that you concatenate the 2.1 exchange name, topic name, and queue name to create a value for the `}<inlineCode parentName="td">{`id`}</inlineCode>{` parameter.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/topic`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/topic`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/destinationType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. This value must be set to `}<inlineCode parentName="td">{`queue`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/destination`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/<queue>/name`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<arguments>`}</inlineCode>{` and `}<inlineCode parentName="td">{`<exchange>/<binding>/<arguments>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this element.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "create-the-queue_publisherxml-file"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_publisher.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_publisher.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.1 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.1 queue.xml source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/topic`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/topic`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>/type`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/exchange`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<broker>exchange`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.1. Omit this parameter to accept the default value.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "migrate-from-20-to-22"
    }}>{`Migrate from 2.0 to 2.2`}</h2>
    <p>{`To upgrade from Adobe Commerce or Magento Open Source 2.0, you must create the following files in the `}<inlineCode parentName="p">{`<module>/etc`}</inlineCode>{` directory for each module that will use the message queue framework.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`queue_consumer.xml`}</inlineCode>{` - Defines the relationship between an existing queue and its consumer.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_topology.xml`}</inlineCode>{`- Defines the message routing rules.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_publisher.xml`}</inlineCode>{` - Defines the relationship between a topic and its publisher.`}</li>
    </ul>
    <p>{`The existing `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file is deprecated.`}</p>
    <p>{`For complete details about these files, see `}<a parentName="p" {...{
        "href": "configuration.md"
      }}>{`Configure message queues`}</a></p>
    <h3 {...{
      "id": "create-the-queue_consumerxml-file-1"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_consumer.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_consumer.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.0 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.0 queue.xml Source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/name`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/queue`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/queue`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/handler`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use the values from `}<inlineCode parentName="td">{`<consumer>/class`}</inlineCode>{` and `}<inlineCode parentName="td">{`<consumer>/method`}</inlineCode>{` in the format `}<inlineCode parentName="td">{`<Vendor>\\Module\\<ServiceName>::<methodName>`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/consumerInstance`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/executor`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/connection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/connection`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/maxMessages`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<consumer>/max_messages`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "create-the-queue_topologyxml-file-1"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_topology.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_topology.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.0 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.0 queue.xml Source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/exchange`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Set this value to `}<inlineCode parentName="td">{`topic`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/connection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/connection`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/durable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/autoDelete`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/internal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. It is recommended that you concatenate the 2.1 exchange name, topic name, and queue name to create a value for the `}<inlineCode parentName="td">{`id`}</inlineCode>{` parameter.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/topic`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<bind>/topic`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/destinationType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. This value must be set to `}<inlineCode parentName="td">{`queue`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/destination`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<bind>/queue`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<exchange>/<binding>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<arguments>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this element.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "create-the-queue_publisherxml-file-1"
    }}>{`Create the `}<inlineCode parentName="h3">{`queue_publisher.xml`}</inlineCode>{` file`}</h3>
    <p>{`The first column in the following table lists the all the parameters in the `}<inlineCode parentName="p">{`queue_publisher.xml`}</inlineCode>{` file. The second column lists where in the Adobe Commerce and Magento Open Source 2.0 `}<inlineCode parentName="p">{`queue.xml`}</inlineCode>{` file the equivalent parameters are located.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`2.2 Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2.0 queue.xml Source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/topic`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<topic>/name`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/connection`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/exchange`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/exchange`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<publisher>/<connection>/disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not present in 2.0. Omit this parameter to accept the default value.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      